var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt"},[_c('van-grid',{attrs:{"column-num":"1","clickable":"","border":false}},[_c('van-grid-item',{on:{"click":function($event){return _vm.cmdMT(_vm.obj)}}},[(_vm.isSelected(_vm.obj))?_c('div',{staticClass:"selected"},[_vm._v(_vm._s(_vm.obj.id))]):_c('div',{staticClass:"unselect"},[_vm._v(_vm._s(_vm.obj.id))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }